export const Gandhidham = {
    title: "Gandhidham",
    title1: "(Cultural & Historical Attractions)",

    attractions: [
        {
            name: "Purneshwar Temple",
            description: "An ancient Hindu temple with intricate architecture, dedicated to Lord Shiva. The temple is known for its spiritual significance and peaceful ambiance.",
            location: "Gandhidham, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Offer prayers and perform rituals",
                "Explore the temple’s architecture",
                "Attend religious discourses"
            ],
            mapLink: "https://maps.app.goo.gl/purneshwartemple",
        },
        {
            name: "Shree Chandra Prabh Labdhi Dham Teerth",
            description: "A prominent Jain temple known for its serene atmosphere and religious importance. The temple attracts devotees and tourists interested in Jainism.",
            location: "Gandhidham, Gujarat",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Offer prayers and meditate",
                "Explore the temple’s carvings and architecture",
                "Attend spiritual discourses"
            ],
            mapLink: "https://maps.app.goo.gl/jainteerth",
        },
        {
            name: "Gandhidham Town Park",
            description: "A well-maintained park offering lush greenery, walking paths, and recreational activities, making it a great place for relaxation and family outings.",
            location: "Gandhidham, Gujarat",
            timings: "5:00 AM to 10:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Enjoy a peaceful walk",
                "Relax amidst greenery",
                "Playground activities for kids"
            ],
            mapLink: "https://maps.app.goo.gl/gandhidhampark",
        },
        {
            name: "Kandla Port",
            description: "One of India's largest ports, Kandla Port is a crucial commercial hub. Visitors can witness the bustling port operations and learn about maritime trade.",
            location: "Kandla, near Gandhidham, Gujarat",
            timings: "Restricted Access",
            ticket: "Permission Required",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Observe port activities",
                "Learn about maritime trade",
                "Photography of massive cargo ships"
            ],
            mapLink: "https://maps.app.goo.gl/kandlaport",
        },
        {
            name: "Shri Guru Nanak Darbar",
            description: "A peaceful and beautifully maintained Gurudwara offering spiritual solace to visitors of all faiths.",
            location: "Gandhidham, Gujarat",
            timings: "4:30 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "During Gurpurab Festival",
            activities: [
                "Offer prayers and listen to kirtan",
                "Experience the langar (community meal)",
                "Learn about Sikh culture and teachings"
            ],
            mapLink: "https://maps.app.goo.gl/gurunanakdarbar",
        }
    ]
};
